import type { AxiosRequestConfig } from 'axios'
import { httpClient } from '@/configs/axios.config'
import type { DealEmailBody } from '@/types/api'

// A file past retention answers 404; the panel says so instead of navigating.
const sourceFileReadConfig: AxiosRequestConfig & {
  skipNotFoundRedirect: boolean
} = { skipNotFoundRedirect: true }

// No public URLs: the backend streams bytes behind its auth guard, so callers work in blobs.
export async function getDealEmailBody(
  sourceFileId: string
): Promise<DealEmailBody> {
  const response = await httpClient.get<DealEmailBody>(
    `/deal-source-files/${sourceFileId}/email-body`,
    sourceFileReadConfig
  )
  return response.data
}

export async function getDealSourceFileBlob(
  sourceFileId: string
): Promise<Blob> {
  const response = await httpClient.get<Blob>(
    `/deal-source-files/${sourceFileId}/content`,
    { ...sourceFileReadConfig, responseType: 'blob' }
  )
  return response.data
}
